// import React from "react";
// import Sidebar from "./components/sidebar/Sidebar";
// import Topbar from "./components/topbar/Topbar";
// import "./App.css";
// import Home from "./pages/home/Home";
// import { BrowserRouter, Route, Routes } from "react-router-dom";
// import UserList from "./pages/userList/UserList";
// import User from "./pages/user/User";
// import NewUser from "./pages/newUser/NewUser";
// import ProductList from "./pages/productList/ProductList";
// import Product from "./pages/product/Product";
// import NewProduct from "./pages/newProduct/NewProduct";
// import ServiceList from "./pages/services/ServiceList";

// const App = () => {
//   return (
//     <BrowserRouter>
//       <Topbar />
//       <div className="container">
//         <Sidebar />
//         <Routes>
//           <Route exact path="/" element={<Home />} />
//           <Route path="/users" element={<UserList />} />
//           <Route path="/user/:userId" element={<User />} />
//           <Route path="/newUser" element={<NewUser />} />
//           <Route path="/products" element={<ProductList />} />
//           <Route path="/services" element={<ServiceList />} />
//           <Route path="/product/:productId" element={<Product />} />
//           <Route path="/newProduct" element={<NewProduct />} />
//         </Routes>
//       </div>
//     </BrowserRouter>
//   );
// };

// export default App;



import React from "react";
import Sidebar from "./components/sidebar/Sidebar";
import Topbar from "./components/topbar/Topbar";
import "./App.css";
import Home from "./pages/home/Home";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import UserList from "./pages/userList/UserList";
import User from "./pages/user/User";
import NewUser from "./pages/newUser/NewUser";
import ProductList from "./pages/productList/ProductList";
import Product from "./pages/product/Product";
import NewProduct from "./pages/newProduct/NewProduct";
import ServiceList from "./pages/services/ServiceList";
import AdminLogin from "./pages/adminLogin/adminLogin";
import ProtectedRoute from "./pages/adminLogin/protectedRoute";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* LOGIN PAGE */}
        <Route path="/admin-login" element={<AdminLogin />} />

        {/* PROTECTED ADMIN PANEL */}
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Topbar />
              <div className="container">
                <Sidebar />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/users" element={<UserList />} />
                  <Route path="/user/:userId" element={<User />} />
                  <Route path="/newUser" element={<NewUser />} />
                  <Route path="/products" element={<ProductList />} />
                  <Route path="/services" element={<ServiceList />} />
                  <Route path="/product/:productId" element={<Product />} />
                  <Route path="/newProduct" element={<NewProduct />} />
                </Routes>
              </div>
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;